// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-2bac0116]{text-align:center}#space-invaders[data-v-2bac0116]{margin:0 auto;display:block;background:#fff;border-radius:10px;margin-top:30px;margin-bottom:400px}", ""]);
// Exports
module.exports = exports;
